import React from 'react';
import styles from './TextEffectsShook.scss';
import type { TextEffectsSharedProps } from '../../TextEffectsShared/TextEffectsShared.types';
import TextEffectsShared from '../../TextEffectsShared/viewer/TextEffectsShared';
import { TestIds } from '../constants';
import cx from 'clsx';
import { usePatterns, Patterns } from '../../TextEffectsShared/viewer/patterns';

export type TextEffectsShookProps = TextEffectsSharedProps;

const TextEffectsShook: React.FC<TextEffectsSharedProps> = props => {
  const { content, arePatternsDisabled } = usePatterns(props);

  return (
    <TextEffectsShared
      {...props}
      arePatternsDisabled={arePatternsDisabled}
      tagProps={{
        className: styles.container,
        'data-testid': TestIds.viewer.container,
      }}
    >
      <Patterns
        content={content}
        arePatternsDisabled={arePatternsDisabled}
        patternScope={props.patternScope}
        unitProps={() => ({
          className: styles.unit,
          disabledPattern: arePatternsDisabled,
        })}
        unitPredicate={data => (
          <>
            <span
              data-testid={TestIds.viewer.text}
              className={cx(styles.text, styles.block)}
            >
              {data}
            </span>
            <span
              className={cx(styles.layer1, styles.block)}
              data-text={data}
              data-testid={TestIds.viewer.layer}
              aria-hidden="true"
            />
            <span
              className={cx(styles.layer2, styles.block)}
              data-text={data}
              data-testid={TestIds.viewer.layer}
              aria-hidden="true"
            />
            <span
              className={cx(styles.layer3, styles.block)}
              data-text={data}
              data-testid={TestIds.viewer.layer}
              aria-hidden="true"
            />
            <span
              className={cx(styles.layer4, styles.block)}
              data-text={data}
              data-testid={TestIds.viewer.layer}
              aria-hidden="true"
            />
          </>
        )}
      />
    </TextEffectsShared>
  );
};

export default TextEffectsShook;
